import {
  RedoManagedReturnsSortingMode,
  ReturnsSortingMode,
} from "@redotech/redo-return-settings-common/returns-sorting-mode";

export const returnsSortingModeLabels: Record<ReturnsSortingMode, string> = {
  [ReturnsSortingMode.SERVICE_LEVEL]: "Service level",
  [ReturnsSortingMode.PRIORITY]: "Priority",
};

export const redoManagedReturnsSortingModeLabels: Record<
  RedoManagedReturnsSortingMode,
  string
> = {
  [RedoManagedReturnsSortingMode.DEFAULT]: "Default",
  [RedoManagedReturnsSortingMode.HIGH_PRIORITY]: "Priority",
};
